import type { SchemaToType } from '@main/schema-utils';
import { mkInput, mkType } from '@main/schema-utils';
import { SombraStandardScopes } from '@main/sombra-types';

export const PrivacyCenterAccessToken = mkType({
  name: 'PrivacyCenterAccessToken',
  comment: 'Privacy Center Access Token',
  fields: {
    token: {
      comment: 'The token to be used to access the privacy center',
      type: 'string',
    },
  },
});

/** Override type */
export type PrivacyCenterAccessToken = SchemaToType<
  typeof PrivacyCenterAccessToken
>;

export const CreatePrivacyCenterAccessTokenInput = mkInput({
  name: 'CreatePrivacyCenterAccessTokenInput',
  comment: 'Create Privacy Center Access Token Input',
  fields: {
    coreIdentifier: {
      comment: 'The core identifier of the user',
      type: 'string',
      optional: true,
    },
    email: {
      comment: 'The email of the user',
      type: 'string',
    },
    subjectType: {
      comment: 'The subject type of the user',
      type: 'string',
    },
    scopes: {
      comment: 'The scope associated with the token',
      type: { SombraStandardScopes },
      list: true,
    },
    expiresIn: {
      comment: 'The expiration time of the token',
      type: 'int',
      optional: true,
    },
  },
});

/** Override type */
export type CreatePrivacyCenterAccessTokenInput = SchemaToType<
  typeof CreatePrivacyCenterAccessTokenInput
>;

export const CreatePrivacyCenterAccessTokensInput = mkInput({
  name: 'CreatePrivacyCenterAccessTokensInput',
  comment: 'Create Privacy Center Access Tokens Input',
  fields: {
    records: {
      comment: 'The input records to create privacy center access tokens',
      type: CreatePrivacyCenterAccessTokenInput,
      list: true,
    },
  },
});

/** Override type */
export type CreatePrivacyCenterAccessTokensInput = SchemaToType<
  typeof CreatePrivacyCenterAccessTokensInput
>;
